
import { ref } from "@vue/reactivity";
import { isNavigationFailure, useRouter } from "vue-router";
import { onMounted } from '@vue/runtime-core';
import { view } from '@/api/http';
export default {
  setup() {
    const tabs: any = ref<any>([
      {
        lable: "首页",
        router: "/",
        checked: true,
      },
      // {
      //   lable: "免费报告",
      //   router: "/report",
      //   checked: false,
      // },
      {
        lable: "联系我们",
        router: "/connect",
        checked: false,
      },
      {
        lable: "加入我们",
        router: "/join",
        checked: false,
      },
      {
        lable: "关于我们",
        router: "/about",
        checked: false,
      },
    ]);
    const router = useRouter();
    router.afterEach((to, from, failure) => {
      tabs.value.forEach((tab: any) => {
        const path = to.path.replace(/joinDetail/g, "join");
        tab.checked = path === tab.router;
      });
      if (isNavigationFailure(failure)) {
        console.log("failed navigation", failure);
      }
    });
    const checkTab = (checkedTab: any) => {
      router.push(checkedTab.router);
    };
    onMounted(()=>{
      view()
    })
    return {
      tabs,
      checkTab,
    };
  },
};
